import React from "react";
import { Box, Typography } from "@mui/material";
import { C, FONT, eyebrowSx } from "../accountStyles";

/*
 * Read-only member details (from the existing Profile() response).
 * Empty values show "—" rather than "undefined".
 */

function show(value) {
  return value !== null && value !== undefined && String(value).trim() ? value : "—";
}

export function DetailList({ rows }) {
  return (
    <Box
      component="dl"
      sx={{
        m: 0,
        display: "grid",
        gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "repeat(2, minmax(0, 1fr))" },
        columnGap: 4,
        borderTop: `1px solid ${C.line}`,
      }}
    >
      {rows.map((row) => (
        <Box key={row.label} sx={{ py: 2.25, borderBottom: `1px solid ${C.line}`, gridColumn: row.wide ? { sm: "1 / -1" } : undefined, minWidth: 0 }}>
          <Typography component="dt" sx={eyebrowSx}>
            {row.label}
          </Typography>
          <Typography component="dd" sx={{ m: 0, mt: 0.75, fontFamily: FONT, fontSize: "1.05rem", color: C.ink, wordBreak: "break-word" }}>
            {show(row.value)}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default function ProfileDetails({ user }) {
  const fullName = `${user.firstname || ""} ${user.lastname || ""}`.trim();
  return (
    <DetailList
      rows={[
        { label: "Full Name", value: fullName },
        { label: "Phone Number", value: user.phone },
        { label: "Email Address", value: user.email },
        { label: "Member Status", value: "Verified Member" },
      ]}
    />
  );
}
